var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.message && _vm.item.key === _vm.message.key)?_c('div',[_c('p',{staticClass:"has-text-weight-bold"},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far",class:_vm.item.icon})]),_c('span',[_vm._v(_vm._s(_vm.item.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }